<template>
  <div class="teacher_courses_page flex-col">
    <div class="page_title_wrapper">
      <span class="page_title">选择课程</span>
    </div>
    <div class="course_list_container flex-col">
      <DataTable
        :headers="tableHeaders"
        :items="loopData"
        @item-click="handleItemClick"
      />
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue"
import { useRouter } from "vue-router"
import { useStore } from "vuex"

import alovaInstance from "@/utils/alova"
import DataTable from "@/components/teacher/DataTable.vue"

const store = useStore()
const router = useRouter()
const tableHeaders = [
  {
    key: "diffcult_level",
    label: "难度",
    style: "width: 6.8vw;",
    cellStyle: "width: 11.4vw;",
  },
  {
    key: "course_name",
    label: "课程",
    style: "width: 9.8vw;",
    cellStyle: "width: 30vw;text-align: left;margin-left: 2.5vw;",
  },
  {
    key: "course_count",
    label: "堂数",
    style: "width: 58vw;",
    cellStyle: "width: 10vw;margin-left: 24.6vw;",
  },
]

// const loopData = ref([
//   {
//     id: 3,
//     diffcult_level: "3",
//     course_name: "三年级上学期",
//     course_count: 16,
//   },
// ])
const loopData = ref([])

onMounted(async () => {
  try {
    let response = await alovaInstance.Post("/Course/GetCoursesByUserId")
    // console.log(response)
    if (response.code === 1000) {
      loopData.value = response.data
      // loopData.value = loopData.value.concat(loopData.value).concat(loopData.value)
    } else {
      alert("获取信息失败")
    }
  } catch (error) {
    console.error("获取失败:", error)
    alert("获取失败，请稍后重试")
  }
})

const handleItemClick = (item) => {
  store.dispatch("setCourseBase", {
    courseId: item.id,
    courseName: item.course_name,
  })
  router.push({
    path: "/teacher/course",
    query: { courseId: item.id, courseName: item.course_name },
  })
}
</script>

<style src="@/assets/common.css" />
<style scoped>
.teacher_courses_page {
  background-color: rgba(234, 238, 242, 1);
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding-left: 2.2vw;
}

.page_title_wrapper {
  width: 22.24vw;
  height: 1.67vw;
  margin: 1.14vw 0 0 1.65vw;
}

.page_title {
  width: 5vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.25vw;
}

.course_list_container {
  position: relative;
  width: 80.68vw;
  height: auto;
  min-height: 40vw;
  margin-top: 0.6vw;
}
</style>
